export default "__VITE_PUBLIC_ASSET__b2083fe2__"